import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ILayerInteractions } from '@obvious.tech/constellation'

export const LayerInteractions = defineEntity('LayerInteractions', {
  endpoint: 'geolocation/api/LayerInteractions',
  schema: SNoop<ILayerInteractions>(),
})
